import React from 'react';
import {Table} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";

export default class SupplierMeterTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.serialNumber || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.meterType || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.fromReading || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.fromReadingDate || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.fromReadingType || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.toReading || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.toReadingDate || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.toReadingType || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.consumption || <NoData/>}</Table.Cell>
            </Table.Row>
        );
    }
}